import s from "styled-components";
import { CircleButton } from "_c/button";
import { Link } from "react-router-dom";

export const Wrap = s.div`
  display: flex;
  align-items: center;
`;

export const Badge = s(CircleButton).attrs({
  as: "span",
})`
  margin: 0 5px;
  cursor: help;
  :first-child {
    margin-left: 0;
  }
`;
export const SaloonBadge = s(Badge).attrs({
  as: Link,
})`
  cursor: pointer;
`;
export const AttentionSign = s.span`
  color: white;
  font-size: 21px;
  font-weight: 600;
  margin-top: -2px;
`;
